<template>
  <div class="page">
    <div class="buttom1" @click="beforeClose"></div>
    <div class="box overlayclass">
      <div style="padding: 30px 10px 0 10px">
        <div class="plateUls">
          <div class="headerTitle">
            <span></span>
            {{ $t('semi_rematch.semi_rule_title') }}
            <span></span>
            <img :src="require('@/assets/image/open.png')" alt="" />
          </div>
          <div class="formCenternt">
            <p class="P_1">{{ $t('semi_rematch.semi_rule_info') }}</p>
            <p class="P_2">{{ $t('semi_rematch.semi_rule_txt_1') }}</p>
            <p class="P_2">{{ $t('semi_rematch.semi_rule_txt_2') }}</p>
            <p class="P_2">{{ $t('semi_rematch.semi_rule_txt_3') }}</p>
            <!-- 參賽影片要求 -->
            <div class="uls">
              <div class="ulsTitle">
                <div class="left_icon">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <div>{{ $t('semi_rematch.semi_rule_title_1') }}</div>
                <div class="right_icon">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <!-- <span class="xuhao">① </span> -->
                  1. {{ $t('semi_rematch.semi_rule_info_1_1') }}
                </p>
                <p class="P_3">
                  <span>①</span> {{ $t('semi_rematch.semi_rule_txt_1_1_1') }}
                </p>
                <p class="P_3"><span>② </span>{{ $t('semi_rematch.semi_rule_txt_1_1_2') }}</p>
                <p class="P_3"><span>③</span> {{ $t('semi_rematch.semi_rule_txt_1_1_3') }}</p>
                <p class="P_3"><span>④</span> {{ $t('semi_rematch.semi_rule_txt_1_1_4') }}</p>
                <p class="P_3"><span>⑤</span> {{ $t('semi_rematch.semi_rule_txt_1_1_5') }}</p>
                <p class="P_3"><span>⑥</span> {{ $t('semi_rematch.semi_rule_txt_1_1_6') }}</p>
                <p class="P_3"><span>⑦</span> {{ $t('semi_rematch.semi_rule_txt_1_1_7') }}</p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <!-- <span class="xuhao">② </span> -->
                  2. {{ $t('semi_rematch.semi_rule_info_1_2') }}
                </p>
                <p class="P_3"><span>① </span>{{ $t('semi_rematch.semi_rule_txt_2_1') }}</p>
                <p class="P_3"><span>② </span>{{ $t('semi_rematch.semi_rule_txt_2_2') }}</p>
                <p class="P_3"><span>③ </span>{{ $t('semi_rematch.semi_rule_txt_2_3') }}</p>
                <p class="P_3"><span>④ </span>{{ $t('semi_rematch.semi_rule_txt_2_4') }}</p>
                <p class="P_3"><span>⑤ </span>{{ $t('semi_rematch.semi_rule_txt_2_5') }}</p>
                <p class="P_3"><span>⑥ </span>{{ $t('semi_rematch.semi_rule_txt_2_6') }}</p>
                <p class="P_3"><span>⑦ </span>{{ $t('semi_rematch.semi_rule_txt_2_7') }}</p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <!-- <span class="xuhao">③ </span> -->
                  3. {{ $t('semi_rematch.semi_rule_info_1_3') }}
                </p>
                <p class="P_3">
                  <span>① </span>{{ $t('semi_rematch.semi_rule_txt_3_1') }}
                </p>
                <p class="P_3">
                  <span>② </span>{{ $t('semi_rematch.semi_rule_txt_3_2') }}
                </p>
                <p class="P_3">
                  <span>③ </span>{{ $t('semi_rematch.semi_rule_txt_3_3') }}
                </p>
              </div>
            </div>
            <!-- 影片上傳要求 -->
            <div class="uls">
              <div class="ulsTitle">
                <div class="left_icon">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <div>{{ $t('semi_rematch.semi_rule_title_2') }}</div>
                <div class="right_icon">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <span class="xuhao">① </span>
                  {{ $t('semi_rematch.semi_rule_info_2_1') }}
                </p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <span class="xuhao">② </span
                  >{{ $t('semi_rematch.semi_rule_info_2_2') }}
                </p>
                <p class="P_3">
                  {{ $t('semi_rematch.semi_rule_txt_2_2_1') }}
                </p>
                <p class="P_3">
                  {{ $t('semi_rematch.semi_rule_txt_2_2_2') }}
                </p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <span class="xuhao">③ </span
                  >{{ $t('semi_rematch.semi_rule_txt_2_2_3') }}
                </p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <span class="xuhao">④ </span
                  >{{ $t('semi_rematch.semi_rule_txt_2_2_4') }}
                </p>
              </div>
              <div class="ulsCentent2">
                <p class="title">
                  <span class="xuhao">⑤ </span
                  >{{ $t('semi_rematch.semi_rule_txt_2_2_5') }}
                </p>
              </div>
            </div>
          </div>
          <!-- TODO:0401 -->
          <!-- <div class="upload_button">
            <div class="but" style="filter: grayscale(1);" @click="handleUploadVideo()">
              <img :src="require('@/assets/image/fusai/yunshang.png')" />
              {{ $t('achievement.click_upload_video') }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RematchModal',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    beforeClose() {
      this.$emit('cancel')
      this.isSuccess = false
    },
    handleUploadVideo(e) {
      // TODO: 0328
      this.$dialog
      .alert({
        title: '',
        message: this.$t('achievement.semi_ended'),
        confirmButtonText: this.$t('other_pages.confirm')
      })
      .then(() => {
        // on close
      })
      return;
      const currentPath = this.$route.path
      const isAchievementRoute = currentPath.includes('achievement')
      if (isAchievementRoute) {
        this.$router.push({
          path: '/',
          query: {
            uploadVideo: true
          }
        })
      } else {
        this.beforeClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.page {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;

  .buttom1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 777;
  }

  .box {
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    max-height: 100%;
    overflow-y: auto;
    z-index: 888;
    transform: translate3d(-50%, -50%, 0);
    transition: transform 0.3s, -webkit-transform 0.3s;
  }
}
.overlayclass {
  display: flex;
  align-items: center;
  justify-content: center;
}

.plateUls {
  width: 100%;
  background: #ffd123;
  border-radius: 32px 32px 10px 10px;
  padding: 6px;
  box-sizing: border-box;
  // margin-bottom: 18px;

  .headerTitle {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #fff;
    font-weight: 600;
    border-radius: 32px 32px 10px 10px;
    background-color: #eca300;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 8px;
    text-shadow: 0px 2px 0px #8f6300;

    span {
      width: 20px;
      height: 3px;
      background: #ffffff;
      border-radius: 2px 2px 2px 2px;
    }

    span:nth-child(1) {
      margin-right: 20px;
    }

    span:nth-child(2) {
      margin-left: 20px;
    }

    img {
      width: 50px;
      height: 60px;
      position: absolute;
      left: 0;
      top: -50%;
    }
  }

  .formCenternt {
    background-color: #fff;
    // border: 1px solid red;
    // width: 99;
    border-radius: 8px;
    padding: 20px 10px 50px;
    box-sizing: border-box;
    text-align: left;
    max-height: 70vh;
    overflow-x: hidden;
    line-height: 1.4;
    .P_1 {
      font-size: 14px;
      color: #ff5a25;
    }
    .P_2 {
      margin-top: 10px;
      font-size: 12px;
      color: #999999;
    }
    .uls {
      width: 100%;
      margin-top: 20px;
      .ulsTitle {
        width: 100%;
        padding: 10px 0;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        border-radius: 8px;
        background-color: #ff5a25;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
        .right_icon {
          display: flex;
          align-items: center;
          div:nth-child(3) {
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background-color: #fff;
            margin-left: 7px;
          }
          div:nth-child(2) {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background-color: #fff;
            margin-left: 7px;
          }
          div:first-child {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 4px;
            background-color: #fff;
            margin-left: 7px;
          }
        }

        .left_icon {
          display: flex;
          align-items: center;
          div:first-child {
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background-color: #fff;
            margin-right: 7px;
          }
          div:nth-child(2) {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background-color: #fff;
            margin-right: 7px;
          }
          div:nth-child(3) {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 4px;
            background-color: #fff;
            margin-right: 7px;
          }
        }
      }
      .ulsCentent2 {
        margin-bottom: 5px;
        text-align: left;
        .title {
          display: flex;
          gap: 5px;
          color: #ff5a25;
          font-size: 13px;
        }
        .xuhao {
          font-size: 16px;
        }
        .P_3 {
          display: flex;
          gap: 5px;
          margin-top: 5px;
          font-size: 12px;
          color: #999;
        }
        .focus {
          color: #ff5a25;
        }
      }
    }
  }
  .upload_button {
    width: 100%;
    position: fixed;
    bottom: 15px;
    right: 0;
    z-index: 999;

    .but {
      width: 72%;
      padding: 10px;
      background: #ff7e18;
      font-size: 14px;
      font-family: PingFang SC-Semibold, PingFang SC;
      border-radius: 6px 6px 6px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      margin: auto;

      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
}
</style>
